import React, { useState } from "react";
import { Box, List, ListItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { personCancel } from "../images";
import Text from "../text/Text";
import {
  closeAccount,
  closeAccountHeader,
  closeAccountInstructions,
  deleteAccountCondition,
} from "../messages";
import { CustomCheckbox } from "../checkBox/CheckBox";
import Button from "../button/Button";
import CustomDivider from "../divider/Divider";
import CommonHeader from "../CommonHeader";

function CloseAccount() {
  const navigation = useNavigate();
  const [isChecked, setIsChecked] = useState(false);

  return (
    <>
      <CommonHeader textAfterIcon={closeAccount} icon="backArrow" />
      <Box className="options-container">
        <Box className="close-account-wrapper">
          <Box className="module-container">
            <Box className="module-container-content">
              <Box textAlign="center">
                <img src={personCancel} height="54px" width="54px" />
                <Text className="default-text" size={22} font="bold">
                  {closeAccountHeader}
                </Text>
              </Box>
              <List component="ol" sx={{ padding: "0", marginTop: "10px" }}>
                {closeAccountInstructions.map((inst, index) => {
                  return (
                    <ListItem
                      sx={{ display: "flex", alignItems: "baseline" }}
                      key={index}
                    >
                      <Text
                        className="grey-text"
                        size={16}
                        font="regular"
                        sx={{ marginRight: "5px" }}
                      >
                        {`${index + 1}. `}
                      </Text>
                      <Text className="grey-text" size={16} font="regular">
                        {inst}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
              <CustomCheckbox
                onChange={(_e, checked) => setIsChecked(checked)}
                checked={isChecked}
                name="termsAndPrivacy"
                label={deleteAccountCondition}
              />
            </Box>
            <Box className="module-container-footer">
              <CustomDivider className="settings-divider" />
              <Button
                disabled={!isChecked}
                fullWidth
                variant="contained"
                className="settings-button"
                label={closeAccount}
                onClick={() =>
                  navigation(
                    "/settings/advance-settings/close-account/verification"
                  )
                }
                color="error"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default CloseAccount;
